module.exports = __webpack_public_path__ + "static/python-8b34971a5a30035db8480a8f2358888b.png";